import React, { useState, useRef, useEffect } from 'react';
import { 
  FiFile, 
  FiDownload, 
  FiTrash, 
  FiUploadCloud, 
  FiUser, 
  FiMail, 
  FiPhone, 
  FiMapPin, 
  FiDollarSign, 
  FiInfo, 
  FiCalendar, 
  FiFileText,
  FiSend 
} from 'react-icons/fi';
import { BsBuildings } from "react-icons/bs";
import OffCanvas from '../../../../app/components/OffCanvas';
import { Button } from '../../../../app/components/Button';
import Toast from '../../../../app/components/Toast';
import { Tabs } from '../../../../app/components/Tabs';

const RecorrentOffCanvas = ({ item, onStatusChange }) => {
  const [activeTab, setActiveTab] = useState('anexos');
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadComplete, setUploadComplete] = useState(false);
  const fileInputRef = useRef(null);
  const [anexos, setAnexos] = useState([]);
  const [toast, setToast] = useState({ show: false, type: 'success', message: '' });
  const [dadosItem, setDadosItem] = useState(null);

  const primeiroGrupoTabs = [
    { name: 'Anexos', icon: null },
    { name: 'Contatos', icon: null },
    { name: 'Informações da Empresa', icon: null }
  ];

  const segundoGrupoTabs = [
    { name: 'Leituras de e-mail', icon: null },
    { name: 'E-mails Enviados', icon: null },
    { name: 'Conexão', icon: null }
  ];

  const tabMapping = {
    'Anexos': 'anexos',
    'Contatos': 'contatos',
    'Informações da Empresa': 'informacoes',
    'Leituras de e-mail': 'leituras',
    'E-mails Enviados': 'emails',
    'Conexão': 'conexao'
  };

  const reverseTabMapping = Object.entries(tabMapping).reduce((acc, [key, value]) => {
    acc[value] = key;
    return acc;
  }, {});

  useEffect(() => {
    return () => {
    };
  }, []);

  useEffect(() => {
    if (item) {
      setDadosItem(item);
      setActiveTab('anexos');
      setSelectedFile(null);
      setUploadProgress(0);
      setUploadComplete(false);
      
      const mockAnexos = [
        {
          id: 1,
          nome: `Documento ${item.id}_${item.obrigacao_nome?.substring(0, 10) || 'Doc'}.pdf`,
          tamanho: Math.floor(Math.random() * 1000) + 100,
          status: item.id % 2 === 0 ? 'Entregue' : 'Pendente',
          data: new Date().toLocaleDateString()
        },
        {
          id: 2,
          nome: `Recibo ${item.id}_${item.competencia?.split('-')[0] || '2025'}.pdf`,
          tamanho: Math.floor(Math.random() * 500) + 50,
          status: item.id % 3 === 0 ? 'Entregue' : 'Pendente',
          data: new Date(Date.now() - 86400000).toLocaleDateString()
        }
      ];
      
      if (item.id % 4 === 0) {
        mockAnexos.push({
          id: 3,
          nome: `Comprovante_${item.razao_social?.substring(0, 8) || 'Empresa'}.pdf`,
          tamanho: Math.floor(Math.random() * 300) + 20,
          status: 'Entregue',
          data: new Date(Date.now() - 172800000).toLocaleDateString()
        });
      }
      
      setAnexos(mockAnexos);
    }
  }, [item]);

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      setUploadProgress(0);
      setUploadComplete(false);
    }
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  const handleUpload = () => {
    if (!selectedFile) return;

    setIsUploading(true);
    setUploadProgress(0);

    const interval = setInterval(() => {
      setUploadProgress(prev => {
        const newProgress = prev + 10;

        if (newProgress >= 100) {
          clearInterval(interval);
          setTimeout(() => {
            setIsUploading(false);
            setUploadComplete(true);
            
            const novoAnexo = {
              id: anexos.length + 1,
              nome: selectedFile.name,
              tamanho: Math.floor(selectedFile.size / 1024),
              status: 'Entregue',
              data: new Date().toLocaleDateString()
            };
            
            setAnexos([...anexos, novoAnexo]);
            
            if (dadosItem && onStatusChange) {
              onStatusChange(dadosItem.id, "Entregue");
            }
          }, 500);
          return 100;
        }

        return newProgress;
      });
    }, 300);
  };

  const handleCancel = () => {
    setSelectedFile(null);
    setUploadProgress(0);
    setIsUploading(false);
    setUploadComplete(false);
  };

  const handleDownload = (anexo) => {
    console.log(`Fazendo download do arquivo: ${anexo.nome}`);
  };

  const handleRemoveAnexo = (anexoId) => {
    setAnexos(anexos.filter(anexo => anexo.id !== anexoId));
    setToast({
      show: true,
      type: 'success',
      message: 'Anexo removido com sucesso!'
    });
  };

  const handleOffCanvasClose = () => {
    setDadosItem(null);
  };

  if (!dadosItem && !item) {
    return null;
  }

  const renderTabContent = () => {
    const itemAtual = dadosItem || item;
    
    switch (activeTab) {
      case 'anexos':
        return (
          <div className="p-4">
            <h3 className="text-sm font-medium mb-4">Anexos do Documento</h3>
            
            <div className="mb-4">
              {anexos.length > 0 ? (
                <div className="grid grid-cols-1 gap-3">
                  {anexos.map((anexo) => (
                    <div key={anexo.id} className="bg-white rounded-lg border border-gray-100 p-3 relative">

                      <button
                          type="button"
                          className="absolute -top-1 -right-1 bg-white p-[0.09rem] text-red-500 text-sm"
                          onClick={() => handleRemoveAnexo(anexo.id)}
                        >
                          <FiTrash />
                      </button>
                      
                      <div className="flex items-start">
                        <FiFile size={14} className="mr-2 mt-0.5" />
                        <div>
                          <p className="text-sm font-medium text-gray-700 truncate max-w-[180px]">{anexo.nome}</p>
                          <p className="text-xs text-gray-500">{anexo.tamanho} KB • {anexo.data}</p>
                        </div>
                      </div>

                      
                      <div className="flex justify-between items-center mt-3">
                        <button
                          onClick={() => handleDownload(anexo)}
                        >
                          <FiDownload size={14} />
                        </button>
                        
                        <span className={`px-2 py-[0.10rem] text-xs leading-5 font-normal rounded-full ${
                          anexo.status === 'Entregue' 
                            ? 'bg-[#3b82f626] text-[#1d4ed8]' 
                            : 'bg-[#eab30826] text-[#a16207]'
                        }`}>
                          {anexo.status}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-4 text-gray-500 text-sm">
                  Nenhum anexo disponível para este documento.
                </div>
              )}
            </div>
            
            <div className="bg-white rounded-lg p-4">
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileSelect}
                className="hidden"
              />

              <div className="text-center py-4">
                <p className="text-xs text-gray-500 mb-2">Clique abaixo para adicionar um novo arquivo</p>
                <div
                  className={`border-2 border-dashed ${selectedFile ? 'border-[#a04ccb]' : 'border-gray-300'} rounded-xl p-6 mb-4 cursor-pointer hover:bg-gray-50 transition`}
                  onClick={triggerFileInput}
                >
                  {selectedFile ? (
                    <div className="flex flex-col items-center">
                      <div className="flex items-center justify-center mb-2 w-8 h-8 rounded-full bg-blue-100 text-[#a04ccb]">
                        <FiFile size={16} />
                      </div>
                      <p className="text-sm font-medium text-gray-700">{selectedFile.name}</p>
                      <p className="text-xs text-gray-500 mt-1">
                        {(selectedFile.size / 1024).toFixed(2)} KB
                      </p>
                      {(isUploading || uploadComplete) && (
                        <div className="w-full mt-4 bg-gray-200 rounded-full h-1.5">
                          <div
                            className={`h-1.5 rounded-full ${uploadComplete ? 'bg-green-600' : 'bg-[#a04ccb]'}`}
                            style={{ width: `${uploadProgress}%` }}
                          ></div>
                        </div>
                      )}
                      {uploadComplete && (
                        <p className="text-xs text-green-600 mt-2 flex items-center">
                          <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                          </svg>
                          Upload concluído
                        </p>
                      )}
                    </div>
                  ) : (
                    <div>
                      <FiUploadCloud size={40} className="text-gray-300 mx-auto mb-2" />
                      <p className="text-xs text-gray-400">Clique aqui para selecionar um arquivo</p>
                    </div>
                  )}
                </div>
                <div className="flex justify-end space-x-2">
                  <Button
                    variant="primary"
                    onClick={handleUpload}
                    disabled={!selectedFile || isUploading || uploadComplete}
                  >
                    {isUploading ? 'Enviando...' : 'Enviar'}
                  </Button>
                  <Button
                    variant="outline"
                    onClick={handleCancel}
                    disabled={!selectedFile || isUploading}
                  >
                    Cancelar
                  </Button>
                </div>
              </div>
            </div>
          </div>
        );
        case 'contatos':
          return (
            <div className="p-4">
              <h3 className="text-sm font-medium mb-4">Lista de Contatos</h3>
              <div className="space-y-4">
                {[1, 2, 3].map((_, index) => (
                  <div key={index} className="flex items-center p-3 border border-gray-100 rounded-lg">
                    <div className="mr-2">
                      <FiPhone size={14} />
                    </div>
                    <div>
                      <p className="text-sm font-medium">Contato {index + 1}</p>
                      <p className="text-xs text-gray-500">contato{index + 1}@empresa.com</p>
                    </div>
                    <div className="ml-auto">
                      <Button variant="secondary" size="sm">
                        Contatar
                      </Button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
          case 'informacoes':
            return (
              <div className="p-4">
                <h3 className="text-sm font-medium mb-4">Informações da Empresa</h3>
                <div className="bg-white rounded-lg p-4 border border-gray-100 space-y-4">
                  <div className="flex justify-between">
                    <p className="text-sm text-black flex items-center">
                      <BsBuildings className="mr-2 text-black" size={14} />
                      Razão Social:
                    </p>
                    <p className="text-sm text-[#9ca3af]">{itemAtual?.razao_social || 'Empresa ABC Ltda'}</p>
                  </div>
                  <div className="flex justify-between">
                    <p className="text-sm text-black flex items-center">
                      <FiInfo className="mr-2 text-black" size={14} />
                      Nome Fantasia:
                    </p>
                    <p className="text-sm text-[#9ca3af]">{itemAtual?.nome_fantasia || 'ABC Soluções'}</p>
                  </div>
                  <div className="flex justify-between">
                    <p className="text-sm text-black flex items-center">
                      <FiFileText className="mr-2 text-black" size={14} />
                      CNPJ:
                    </p>
                    <p className="text-sm text-[#9ca3af]">{itemAtual?.cnpj || '12.345.678/0001-90'}</p>
                  </div>
                  <div className="flex justify-between">
                    <p className="text-sm text-black flex items-center">
                      <FiUser className="mr-2 text-black" size={14} />
                      Responsável:
                    </p>
                    <p className="text-sm text-[#9ca3af]">{itemAtual?.responsavel_nome?.split('|')[0].trim() || 'João Silva'}</p>
                  </div>
                  <div className="flex justify-between">
                    <p className="text-sm text-black flex items-center">
                      <FiDollarSign className="mr-2 text-black" size={14} />
                      Regime Tributário:
                    </p>
                    <p className="text-sm text-[#9ca3af]">{itemAtual?.regime_tributario || 'Simples Nacional'}</p>
                  </div>
                  <div className="flex justify-between">
                    <p className="text-sm text-black flex items-center">
                      <FiMapPin className="mr-2 text-black" size={14} />
                      Endereço:
                    </p>
                    <p className="text-sm text-[#9ca3af]">{itemAtual?.endereco || 'Av. Principal, 1000, São Paulo - SP'}</p>
                  </div>
                  <div className="flex justify-between">
                    <p className="text-sm text-black flex items-center">
                      <FiPhone className="mr-2 text-black" size={14} />
                      Telefone:
                    </p>
                    <p className="text-sm text-[#9ca3af]">{itemAtual?.telefone || '(11) 3456-7890'}</p>
                  </div>
                  <div className="flex justify-between">
                    <p className="text-sm text-black flex items-center">
                      <FiMail className="mr-2 text-black" size={14} />
                      E-mail:
                    </p>
                    <p className="text-sm text-[#9ca3af]">{itemAtual?.email || 'contato@empresaabc.com.br'}</p>
                  </div>
                  <div className="flex justify-between">
                    <p className="text-sm text-black flex items-center">
                      <FiCalendar className="mr-2 text-black" size={14} />
                      Ativa:
                    </p>
                    <p className="text-sm">
                      <span className={`px-2 py-[0.10rem] text-xs leading-5 font-normal rounded-full ${
                        itemAtual?.ativa === false 
                          ? 'bg-[#ef444426] text-[#b91c1c]' 
                          : 'bg-[#22c55e26] text-[#15803d]'
                      }`}>
                        {itemAtual?.ativa === false ? 'Não' : 'Sim'}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            );
          case 'leituras':
            return (
              <div className="p-4">
                <h3 className="text-sm font-medium mb-4">Histórico de Leituras de E-mail</h3>
                <div>
                  <div className="space-y-4">
                    {[1, 2, 3].map((_, index) => (
                      <div key={index} className="border border-gray-100 rounded-lg p-3">
                        <div className="flex justify-between items-center mb-2">
                          <div className="flex items-center">
                            <FiMail className="mr-2" size={14} />
                            <p className="text-sm font-medium">E-mail {index + 1}</p>
                          </div>
                          <span className="text-xs text-gray-400">{new Date(Date.now() - index * 86400000).toLocaleDateString()}</span>
                        </div>
                        <p className="text-xs text-gray-600 mb-1">Aberto por: {['João', 'Maria', 'Carlos'][index]}</p>
                        <p className="text-xs text-gray-600">Horário: {['09:45', '14:30', '11:15'][index]}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            );
            case 'emails':
              return (
                <div className="p-4">
                  <h3 className="text-sm font-medium mb-4">E-mails Enviados</h3>
                  <div className="space-y-4">
                    {[1, 2, 3].map((_, index) => (
                      <div key={index} className="border border-gray-100 rounded-lg p-4">
                        <p className="text-xs text-gray-500 mb-2">Para: {itemAtual?.razao_social || 'Empresa'}</p>
                        <div className="flex items-center gap-2">
                          <FiSend size={14} />
                          <div className="text-sm font-medium">{['Confirmação de Pagamento', 'Aviso de Vencimento', 'Atualização Cadastral'][index]}</div>
                        </div>
                        <div className="text-sm text-gray-600 mt-1">
                          {['Confirmamos o recebimento do pagamento...', 'Informamos que a fatura vence em...', 'Solicitamos a atualização dos dados...'][index]}
                        </div>
                        <div className="text-xs text-gray-400 mt-2">
                          {new Date(Date.now() - index * 86400000).toLocaleDateString()}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              );
      case 'conexao':
        return (
          <div className="p-4">
            <h3 className="text-sm font-medium mb-4">Conexão</h3>
            <div className="bg-white rounded-lg p-4 border border-gray-100">
              <div className="flex flex-col items-center justify-center py-6">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                  <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
                  </svg>
                </div>
                <p className="text-sm font-medium mb-2">Conectar este card</p>
                <p className="text-xs text-gray-500 text-center mb-4">
                  Conecte este card a outros sistemas ou documentos relacionados
                </p>
                <div className="w-full space-y-2">
                  <Button variant="outline" className="w-full justify-center">
                    Conectar a um documento
                  </Button>
                  <Button variant="outline" className="w-full justify-center">
                    Conectar a um sistema
                  </Button>
                  <Button variant="primary" className="w-full justify-center">
                    Criar nova conexão
                  </Button>
                </div>
              </div>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <OffCanvas
      onClose={handleOffCanvasClose}
    >
      <div>
        <div className="flex items-center px-4 pb-2 border-b border-gray-100">
          <div className="flex items-center justify-center mr-3">
            <BsBuildings size={18} />
          </div>
          <h3 className="text-base font-medium">{dadosItem?.razao_social || item?.razao_social || 'Empresa'}</h3>
        </div>
        
        <div className="mt-4 px-4">
          <Tabs
            tabs={primeiroGrupoTabs}
            activeTabName={reverseTabMapping[activeTab]}
            onTabClick={(tabName) => {
              setActiveTab(tabMapping[tabName]);
            }}
          />
        </div>
        
        <div className="mt-2 px-4">
          <Tabs
            tabs={segundoGrupoTabs}
            activeTabName={reverseTabMapping[activeTab]}
            onTabClick={(tabName) => {
              setActiveTab(tabMapping[tabName]);
            }}
          />
        </div>

        <div className="mt-4">
          {renderTabContent()}
        </div>
      </div>
      {toast.show && (
        <Toast
          type={toast.type}
          message={toast.message}
          duration={3000}
          onClose={() => setToast({ ...toast, show: false })}
        />
      )}

    </OffCanvas>
  );
};

RecorrentOffCanvas.open = (item) => {
  OffCanvas.open(item);
};

RecorrentOffCanvas.close = () => {
  OffCanvas.close();
};

RecorrentOffCanvas.init = () => {
  OffCanvas.init();
};

export default RecorrentOffCanvas;